import { IN_RESERVATION } from "actions/reservation/IN_RESERVATION";

/**
 * @name inResAccelerateCheckInRadioButton
 * @returns {Function}
 */
export const inResAccelerateCheckInRadioButton = (data) => ({
    type: IN_RESERVATION.IN_RES_ACCELERATE_CHECK_IN_SAVE_TIME,
    data,
});